import { profile, axiosConfig } from 'api';

import { Response } from 'models/response';

export interface PhotoUpload {
  userId: string;
  file: File | '';
}

export interface PhotoResponse {
  picture: string;
  extension: string;
}

export const getPhoto = (): Promise<Response<PhotoResponse>> =>
  profile.get<Response<PhotoResponse>>('users/getPictureByUserId', axiosConfig).then((response) => response.data);

export const upload = (data: FormData): Promise<void> => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };

  return profile
    .post('users/uploadUserPicture', data, config)
    .then((response) => true)
    .catch((error) => error.data);
};
